import styled from 'styled-components';

export const DescriptionSection = styled.div`
    padding: 0 calc(100vw*(20/375));
`
export const SectionTitle = styled.h3`
    font-size: calc(100vw*(18/375));
    font-weight: bold;
    line-height: 1.11;
    margin-bottom: calc(100vw * (18 / 375));
`
export const ContentArea = styled.div`
    width: 100%;
    font-size: calc(100vw*(14/375));
    line-height: calc(100vw*(23/375));
    background-color: #ffffff; 
    white-space: pre-wrap;
    word-break: break-all;
    padding-left: calc(100vw * (2 / 375));

    a {
        color: #0000ff;
    }
`;